import React from 'react'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {

  faHeart,
  faShareAlt,
} from "@fortawesome/free-solid-svg-icons";
export default function BuyPriceBlock({handleWishlist,isWishlisted,user,propData,bhkdata,activeBhk,scrollToSchedule,activeFloorDetail}) {
  return (
      <div className="property-price-block property-details-block">
                      <div className="row">
                        <div className="col-12">
                          <div className="property-price-details">
                            {/* top-price */}
    
                            <div className="property-price">
                              <div className="start-from-and-like d-flex justify-content-between">
                                <span className="span-text">Starts from</span>
                                <div className="like-share  d-flex justify-content-between gap-3">
                                  <span
                                    className="cursor-pointer"
                                    onClick={handleWishlist}
                                  >
                                    <FontAwesomeIcon
                                      icon={faHeart}
                                      style={{
                                        color:
                                          isWishlisted && user?.isAuthenticated
                                            ? "red"
                                            : "gray",
                                      }}
                                    />
                                  </span>
                                  <Link
                                    className="share-icon"
                                    to={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                                      window.location.href
                                    )}`}
                                    target="_blank"
                                    // onClick={() => shareOnWhatsApp()}
                                  >
                                    <FontAwesomeIcon icon={faShareAlt} />
                                  </Link>
                                </div>
                              </div>
                              <h3>
                                <span>
                                  {propData?.propertyDTO?.priceRange
                                    ? propData?.propertyDTO?.priceRange
                                    : "-"}
                                </span>
                              </h3>
                              <p>
                                Incl. maintenance ∙ Negotiable ∙ Zero Brokerage{" "}
                              </p>
                              {propData?.propertyDTO?.verifiedOwner && (
                                <div className="verified-badge badge d-flex align-items-center gap-1">
                                  <svg
                                    width="20"
                                    height="19"
                                    viewBox="0 0 20 19"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M19.555 8.3033L18.195 6.80267C17.935 6.51774 17.725 5.98588 17.725 5.60597V3.99138C17.725 2.98463 16.855 2.15833 15.795 2.15833H14.095C13.705 2.15833 13.135 1.95888 12.835 1.71195L11.255 0.42027C10.565 -0.14009 9.43504 -0.14009 8.73504 0.42027L7.165 1.72144C6.865 1.95888 6.295 2.15833 5.905 2.15833H4.175C3.115 2.15833 2.245 2.98463 2.245 3.99138V5.61547C2.245 5.98588 2.035 6.51774 1.785 6.80267L0.435 8.3128C-0.145 8.96814 -0.145 10.0319 0.435 10.6872L1.785 12.1973C2.035 12.4823 2.245 13.0141 2.245 13.3845V15.0086C2.245 16.0154 3.115 16.8417 4.175 16.8417H5.905C6.295 16.8417 6.865 17.0411 7.165 17.2881L8.74504 18.5797C9.43504 19.1401 10.565 19.1401 11.265 18.5797L12.845 17.2881C13.145 17.0411 13.705 16.8417 14.105 16.8417H15.805C16.865 16.8417 17.735 16.0154 17.735 15.0086V13.394C17.735 13.0236 17.945 12.4823 18.205 12.1973L19.565 10.6967C20.145 10.0414 20.145 8.95864 19.555 8.3033ZM14.155 7.70495L9.32504 12.2923C9.18504 12.4253 8.99504 12.5013 8.79504 12.5013C8.59504 12.5013 8.40504 12.4253 8.26504 12.2923L5.845 9.99388C5.555 9.71845 5.555 9.26256 5.845 8.98713C6.135 8.7117 6.615 8.7117 6.905 8.98713L8.79504 10.7822L13.095 6.6982C13.385 6.42277 13.865 6.42277 14.155 6.6982C14.445 6.97363 14.445 7.42951 14.155 7.70495Z"
                                      fill="#0099FF"
                                    />
                                  </svg>
                                  <span>Verified Owner</span>
                                </div>
                              )}
                            </div>
    
                            {/* middle-meta-details */}
                            <div className="left-side-meta p-3">
                              <ul className="meta-grid-2">
                                <li>
                                  <div className="property-meta-detail-content">
                                    <div className="icon  p-11">
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11.75 7.75L18.75 0.75M18.75 0.75H14.25M18.75 0.75V5.25M7.75 11.75L0.75 18.75M0.75 18.75H5.25M0.75 18.75V14.25"
                                          stroke="#FF3155"
                                          strokeWidth="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </svg>
                                    </div>
                                    <div className="property-meta-detail">
                                      <span className="meta-label fs-12">Size</span>
                                      <span className="meta-info fs-14">
                                        {propData?.propertyDTO?.buildUpArea
                                          ? `${propData?.propertyDTO?.buildUpArea} SqFt`
                                          : "-"}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                                {/* //if parking details is not null then only show the data */}
                                {propData?.propertyDTO?.shortParkingDetail !==
                                null ? (
                                  <li>
                                    <div className="property-meta-detail-content">
                                      <div className="icon p-11">
                                        <svg
                                          width="17"
                                          height="26"
                                          viewBox="0 0 17 26"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M6.10449 9.32245V12.5512"
                                            stroke="#FF3155"
                                            strokeWidth="1.4325"
                                            stroke-miterlimit="10"
                                          />
                                          <path
                                            d="M6.10449 5.02496H8.25324C8.82313 5.02496 9.36967 5.25135 9.77264 5.65432C10.1756 6.05729 10.402 6.60383 10.402 7.17371C10.402 7.7436 10.1756 8.29014 9.77264 8.69311C9.36967 9.09608 8.82313 9.32246 8.25324 9.32246H6.10449V5.02496Z"
                                            stroke="#FF3155"
                                            strokeWidth="1.4325"
                                            stroke-miterlimit="10"
                                          />
                                          <path
                                            d="M13.6308 0.716248H2.86457C1.67785 0.716248 0.71582 1.67828 0.71582 2.865V13.6312C0.71582 14.818 1.67785 15.78 2.86457 15.78H13.6308C14.8175 15.78 15.7796 14.818 15.7796 13.6312V2.865C15.7796 1.67828 14.8175 0.716248 13.6308 0.716248Z"
                                            stroke="#FF3155"
                                            strokeWidth="1.4325"
                                            stroke-miterlimit="10"
                                          />
                                          <path
                                            d="M8.25293 15.78V25.4662"
                                            stroke="#FF3155"
                                            strokeWidth="1.4325"
                                            stroke-miterlimit="10"
                                          />
                                        </svg>
                                      </div>
                                      <div className="property-meta-detail">
                                        <span className="meta-label fs-12">
                                          Parking
                                        </span>
                                        <span className="meta-info fs-14">
                                          {propData?.propertyDTO?.shortParkingDetail
                                            ? propData.propertyDTO
                                                .shortParkingDetail
                                            : "-"}
                                        </span>
                                      </div>
                                    </div>
                                  </li>
                                ) : null}
                                {activeFloorDetail?.length !== null &&
                                activeFloorDetail?.width !== null ? (
                                  <li>
                                    <div className="property-meta-detail-content">
                                      <div className="icon p-11">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 32 32"
                                          fill="transparent"
                                          stroke="#ff3155"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M25.492 1.171c-.609-.61-1.674-.61-2.283 0l-3.557 3.557L4.269 20.111a.46.46 0 0 0-.118.186L.331 31.03a.49.49 0 0 0 .118.521.5.5 0 0 0 .521.118l10.733-3.82a.47.47 0 0 0 .186-.119L27.05 12.57l3.779-3.779a1.61 1.61 0 0 0 0-2.284l-5.337-5.336z" />
                                          <path d="M20.653 8.504a.5.5 0 0 0-.707 0l-12.22 12.22a.5.5 0 1 0 .707.707l12.22-12.22a.5.5 0 0 0 0-.707z" />
                                          <path d="M23.7 11.15a.5.5 0 0 0-.707 0L10.576 23.567a.5.5 0 1 0 .707.707L23.7 11.857a.5.5 0 0 0 0-.707z" />
                                          <path d="M7.607.447a1.53 1.53 0 0 0-2.16 0l-5 5a1.53 1.53 0 0 0 0 2.16l6.66 6.66a.5.5 0 1 0 .707-.707L6.11 11.855 9.285 8.68a.5.5 0 1 0-.707-.707L5.403 11.15 1.154 6.9a.53.53 0 0 1 0-.746l5-5a.53.53 0 0 1 .746 0l6.661 6.661a.5.5 0 1 0 .707-.707L7.607.447z" />
                                          <path d="M24.893 17.733a.5.5 0 1 0-.707.707l6.66 6.66a.53.53 0 0 1 0 .746l-5 5a.53.53 0 0 1-.746 0l-1.637-1.637 3.175-3.175a.5.5 0 1 0-.707-.707l-3.175 3.175-1.716-1.716 1.758-1.758a.5.5 0 1 0-.707-.707l-1.758 1.758-1.893-1.893a.5.5 0 1 0-.707.707l6.66 6.66A1.53 1.53 0 0 0 25.473 32c.391 0 .782-.149 1.08-.447l5-5a1.53 1.53 0 0 0 0-2.16l-6.66-6.66z" />
                                        </svg>
                                      </div>
                                      <div className="property-meta-detail">
                                        <span className="meta-label fs-12">
                                          Dimensions
                                        </span>
                                        <span className="meta-info fs-14 text-lowercase">
                                          {activeFloorDetail?.length} x {activeFloorDetail?.width}{" "}
                                          {"(lxb)"}
                                        </span>
                                      </div>
                                    </div>
                                  </li>
                                ) : null}
    
                                {activeFloorDetail &&  activeFloorDetail?.noOfRooms !== null ? (
                                  <li>
                                    <div className="property-meta-detail-content">
                                      <div className="icon p-11">
                                        <svg
                                          width="18"
                                          height="11"
                                          viewBox="0 0 18 11"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M1.5 0.75C1.5 0.33579 1.16421 0 0.75 0C0.335786 0 0 0.33579 0 0.75V9.75C0 10.1642 0.335786 10.5 0.75 10.5C1.16421 10.5 1.5 10.1642 1.5 9.75V8.25H16.5V9.75C16.5 10.1642 16.8358 10.5 17.25 10.5C17.6642 10.5 18 10.1642 18 9.75V3.75C18 2.09314 16.6568 0.75 15 0.75H9.75C8.92155 0.75 8.25 1.42157 8.25 2.25V6.75H1.5V0.75ZM16.5 3.75V6.75H9.75V2.25H15C15.8285 2.25 16.5 2.92157 16.5 3.75Z"
                                            fill="#FF3155"
                                          />
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M4.875 6C6.32475 6 7.5 4.82475 7.5 3.375C7.5 1.92525 6.32475 0.75 4.875 0.75C3.42525 0.75 2.25 1.92525 2.25 3.375C2.25 4.82475 3.42525 6 4.875 6ZM4.875 4.55992C4.22056 4.55992 3.69005 4.02945 3.69005 3.375C3.69005 2.72056 4.22056 2.19005 4.875 2.19005C5.52943 2.19005 6.05995 2.72056 6.05995 3.375C6.05995 4.02945 5.52943 4.55992 4.875 4.55992Z"
                                            fill="#FF3155"
                                          />
                                        </svg>
                                      </div>
                                      <div className="property-meta-detail">
                                        <span className="meta-label fs-12">
                                          Number of Rooms
                                        </span>
                                        <span className="meta-info fs-14">
                                          {/* {propData?.pricingAndPlainingDto?.noOfRooms
                                        ? propData.pricingAndPlainingDto.noOfRooms
                                        : "-"}{" "} */}
                                          {/* {bhkdata.map((item) =>
                                            item.bhkType === activeBhk ? (
                                              
                                                {item.noOfRooms ?? "-"}
                                                {item.noOfRooms === "1"
                                                  ? " Room"
                                                  : " Rooms"}
                                              </span>
                                            ) : null
                                          )} */}
                                          <span>
                                          {
                                            activeFloorDetail.noOfRooms ?? "-"
                                          }
                                          {
                                            activeFloorDetail.noOfRooms === "1"
                                                  ? " Room"
                                                  : " Rooms"}
                                
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </li>
                                ) : null}
    
                                {activeFloorDetail && activeFloorDetail?.noOfBathRooms !== null ? (
                                  <li>
                                    <div className="property-meta-detail-content">
                                      <div className="icon  p-11">
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M11.75 7.75L18.75 0.75M18.75 0.75H14.25M18.75 0.75V5.25M7.75 11.75L0.75 18.75M0.75 18.75H5.25M0.75 18.75V14.25"
                                            stroke="#FF3155"
                                            strokeWidth="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          />
                                        </svg>
                                      </div>
                                      <div className="property-meta-detail">
                                        <span className="meta-label fs-12">
                                          Number of bathrooms
                                        </span>
                                        <span className="meta-info fs-14">
                                          {/* {bhkdata.map((item) =>
                                            item.bhkType === activeBhk ? (
                                              <span key={item.id}>
                                                {item.noOfBathRooms ?? "-"}
                                                {item.noOfBathRooms === "1"
                                                  ? " Room"
                                                  : " Rooms"}
                                              </span>
                                            ) : null
                                          )} */}
                                           <span >
                                                {activeFloorDetail.noOfBathRooms ?? "-"}
                                                {activeFloorDetail.noOfBathRooms === "1"
                                                  ? " Room"
                                                  : " Rooms"}
                                              </span>
                                        </span>
                                      </div>
                                    </div>
                                  </li>
                                ) : null}
                                {activeFloorDetail && activeFloorDetail?.furnishingStatus !== null ? (
                                  <li>
                                    <div className="property-meta-detail-content">
                                      <div className="icon p-11">
                                        <svg
                                          width="18"
                                          height="13"
                                          viewBox="0 0 18 13"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M6.40861 7.78667e-06C6.43484 7.78667e-06 6.46142 1.59518e-05 6.48837 1.59518e-05H11.5116C11.5386 1.59518e-05 11.5651 7.78667e-06 11.5914 7.78667e-06C12.293 -9.82162e-05 12.7396 -0.000155308 13.1247 0.0744381C14.7022 0.380053 15.9354 1.58112 16.2491 3.11758C16.3075 3.40302 16.3213 3.72319 16.3246 4.16119C17.2915 4.42708 18 5.29264 18 6.3194V8.31267C18 9.55999 17.3321 10.6554 16.3256 11.2781V12.0273C16.3256 12.365 16.0444 12.6388 15.6977 12.6388C15.3509 12.6388 15.0698 12.365 15.0698 12.0273V11.7621C14.8513 11.8024 14.6259 11.8234 14.3953 11.8234H3.60465C3.37415 11.8234 3.1487 11.8024 2.93023 11.7621V12.0273C2.93023 12.365 2.64911 12.6388 2.30233 12.6388C1.95555 12.6388 1.67442 12.365 1.67442 12.0273V11.2781C0.667917 10.6554 0 9.55999 0 8.31267V6.3194C0 5.29264 0.708539 4.42708 1.67539 4.16119C1.67865 3.72319 1.69254 3.40302 1.75083 3.11758C2.06463 1.58112 3.2978 0.380053 4.87534 0.0744381C5.26039 -0.000155308 5.70697 -9.82162e-05 6.40861 7.78667e-06ZM2.93164 4.16184C3.89727 4.4285 4.60465 5.29354 4.60465 6.3194V7.29789C4.60465 7.3204 4.6234 7.33866 4.64651 7.33866H8.37209V1.22313H6.48837C5.68025 1.22313 5.36788 1.22609 5.12034 1.27405C4.04097 1.48315 3.19721 2.30493 2.98252 3.35619C2.94617 3.53413 2.935 3.74644 2.93164 4.16184ZM9.62791 1.22313V7.33866H13.3535C13.3766 7.33866 13.3953 7.3204 13.3953 7.29789V6.3194C13.3953 5.29354 14.1027 4.4285 15.0683 4.16184C15.065 3.74644 15.0539 3.53413 15.0175 3.3562C14.8028 2.30493 13.959 1.48315 12.8796 1.27405C12.6321 1.22609 12.3198 1.22313 11.5116 1.22313H9.62791ZM2.30233 5.30014C1.72435 5.30014 1.25581 5.75653 1.25581 6.3194V8.31267C1.25581 9.57606 2.30742 10.6003 3.60465 10.6003H14.3953C15.6926 10.6003 16.7442 9.57606 16.7442 8.31267V6.3194C16.7442 5.75653 16.2757 5.30014 15.6977 5.30014C15.1197 5.30014 14.6512 5.75653 14.6512 6.3194V7.29789C14.6512 7.99596 14.0701 8.56177 13.3535 8.56177H4.64651C3.92983 8.56177 3.34884 7.99596 3.34884 7.29789V6.3194C3.34884 5.75653 2.8803 5.30014 2.30233 5.30014Z"
                                            fill="#FF3155"
                                          />
                                        </svg>
                                      </div>
                                      <div className="property-meta-detail">
                                        <span className="meta-label fs-12">
                                          Furnishing
                                        </span>
                                        <span className="meta-info fs-14">
                                          {/* {bhkdata.map((item) =>
                                            activeBhk === item.bhkType
                                              ? item.furnishingStatus
                                                ? item.furnishingStatus
                                                : "-"
                                              : null
                                          )} */}
                                          {activeFloorDetail.furnishingStatus ? activeFloorDetail.furnishingStatus : "-"}
                                        </span>
                                      </div>
                                    </div>
                                  </li>
                                ) : null}
                                <li>
                                  <div className="property-meta-detail-content">
                                    <div className="icon p-11">
                                      <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M12.6269 4.42234L7.38871 6.81641C7.13537 6.93221 6.93221 7.13537 6.81641 7.38871L4.42234 12.6269C4.14617 13.2311 4.76855 13.8538 5.37315 13.5777L10.6113 11.1836C10.8646 11.0678 11.0678 10.8646 11.1836 10.6113L13.5777 5.37315C13.8538 4.76855 13.2315 4.14617 12.6269 4.42234ZM9.81944 9.81944C9.36689 10.272 8.6331 10.272 8.18056 9.81944C7.72802 9.36689 7.72802 8.6331 8.18056 8.18056C8.6331 7.72802 9.36689 7.72802 9.81944 8.18056C10.272 8.6331 10.272 9.36689 9.81944 9.81944ZM9 0C4.02931 0 0 4.02931 0 9C0 13.9707 4.02931 18 9 18C13.9707 18 18 13.9707 18 9C18 4.02931 13.9707 0 9 0ZM9 16.2581C4.9979 16.2581 1.74194 13.0021 1.74194 9C1.74194 4.9979 4.9979 1.74194 9 1.74194C13.0021 1.74194 16.2581 4.9979 16.2581 9C16.2581 13.0021 13.0021 16.2581 9 16.2581Z"
                                          fill="#FF3155"
                                        />
                                      </svg>
                                    </div>
                                    <div className="property-meta-detail">
                                      <span className="meta-label fs-12">Facing</span>
                                      <span className="meta-info  fs-14">
                                        {/* {propData?.propertyDTO?.facing
                                          ? propData.propertyDTO.facing
                                          : "-"} */}
                                          {activeFloorDetail?.facing ? activeFloorDetail?.facing :"-"}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                                {activeFloorDetail && activeFloorDetail?.noOfOpenSides !== null ? (
                                  <li>
                                    <div className="property-meta-detail-content">
                                      <div className="icon p-11">
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 26 26"
                                          fill="#ff3155"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M14 3.695L25.2 20.99H2.8L14 3.695zM2.014 22.995h23.004c2.357 0 2.278-1.387 1.61-2.421L15.44 1.555c-.558-.784-2.22-.852-2.88 0L1.372 20.574c-.604 1.129-.685 2.421.642 2.421zM27 24.998H1c-.552 0-1 .448-1 1.001S.448 27 1 27h26c.552 0 1-.448 1-1.001S27.552 24.998 27 24.998z" />
                                        </svg>
                                      </div>
                                      <div className="property-meta-detail">
                                        <span className="meta-label fs-12">
                                          No. of Open Sides
                                        </span>
                                        <span className="meta-info  fs-14">
                                          {/* {bhkdata[0]?.noOfOpenSides
                                            ? bhkdata[0]?.noOfOpenSides
                                            : "-"} */}

                                            {activeFloorDetail?.noOfOpenSides ? activeFloorDetail.noOfOpenSides :"-" }
                                        </span>
                                      </div>
                                    </div>
                                  </li>
                                ) : null}
                              </ul>
                            </div>
    
                            {/* bottom buttons */}
                            <a
                              className="download-brochure-btn btn btn-primary my-2"
                              href={propData?.propertyDTO?.brochure}
                              download
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Download Brochure
                            </a>
                            <button
                              className="Shedule-visit-btn btn btn-primary my-2"
                              onClick={scrollToSchedule}
                            >
                              Schedule a Visit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
  )
}
